import { Text } from '@chakra-ui/react'

export const QuotesQIcon = (props, color) => {
  return (
    <Text ml='0.5rem' color='resolveOrange' fontWeight='1000' {...props}>
      Q
    </Text>
  )
}
